import { INFORMES_IMPRIMIR_START } from '../constants/informes.constants';


export const descargarInforme = ({ informeId, plantillaId, parametros }) => ({
  type: INFORMES_IMPRIMIR_START,
  payload: { informeId, plantillaId, parametros },
});
